import {Col, Row} from 'react-bootstrap';
import {Query, withApollo} from 'react-apollo';
import {PulseLoader} from 'react-spinners';
import SelectBrand from '../../../common/components/SelectBrand';
import Image from '../../../common/components/Image';
import PropTypes from 'prop-types';
import {flowRight as compose} from 'lodash';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router';
import React from 'react';
import gql from 'graphql-tag';
import config from '../../../config/app';
import styled from 'styled-components';
import {HeadDiv} from '../../../common/components/StyledComp';

const GRAPHQL_QUERY_BRAND = gql`
  query brand($id: ID!){
    brand(id: $id){
      id
      name
      createdAt
      isActive
      file {
        id
        token
        filename
      }
    }
  }
`;

const Div = styled.div`
  text-transform: uppercase;
  font-family: 'Segoe UI Bold', sans-serif;
  font-size: 12px;
`;

const DisplayBrandWithSelect = ({t, values, onChange, key}) => {
  const brandId = values[key];
  return (
    <Row className="section-info">
      <HeadDiv className="info-header">{`${t('brandInfo')} : `}</HeadDiv>
      <Col xs={12} className="brand-info">
        <label className="brand-label">
          {brandId !== 0 && (
            <Query query={GRAPHQL_QUERY_BRAND} variables={{id: brandId}}>
              {({data, loading, error}) => {
                if (loading) {
                  return <PulseLoader loading={true}/>;
                }
                if (error) {
                  console.error(error);
                  return <></>;
                }
                if (data && data.brand) {
                  return (
                    <Row className="brand-info table-container">
                      <Col xs={9} className="extended-col">
                        <label>
                          <Div className="attribute-name">{`${t('brand')} : `}</Div>
                          <label>
                            <SelectBrand
                              onChange={option => onChange(key, option.value)}
                              value={{value: brandId, label: data.brand.name}}
                              lightStyles
                            />
                          </label>
                        </label>
                      </Col>
                      <Col xs={3} className="brand-logo">
                        {data.brand.file && (
                          <Image
                            src={config.api_file_brand + data.brand.id + '?token=' + data.brand.file.token}/>
                        )}
                      </Col>
                    </Row>
                  );
                }
              }}
            </Query>
          )}
        </label>
      </Col>
    </Row>
  );
};


DisplayBrandWithSelect.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  key: PropTypes.string,
};

DisplayBrandWithSelect.defaultProps = {
  key: 'brandId',
};

export default compose(
  withTranslation('merchant'),
  withRouter,
  withApollo,
)(DisplayBrandWithSelect);
